<script setup lang="ts">
import { computed } from "vue";

interface Props {
  modelValue: string;
  type?: string;
  placeholder?: string;
  label?: string;
  error?: string;
  disabled?: boolean;
  id?: string;
}

const props = withDefaults(defineProps<Props>(), {
  type: "text",
  placeholder: "",
  label: "",
  error: "",
  disabled: false,
  id: "",
});

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const inputId = computed(
  () => props.id || `input-${Math.random().toString(36).substr(2, 9)}`,
);
</script>

<template>
  <FormKit
    :id="inputId"
    :type="type"
    :value="modelValue"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    :errors="error ? [error] : []"
    @input="emit('update:modelValue', $event)"
    outer-class="$reset"
    wrapper-class="$reset"
    label-class="block text-sm font-medium text-gray-700 mb-1"
    input-class="w-full px-4 py-2.5 border border-gray-300 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-sbsa-blue focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
    messages-class="text-sm text-red-500 mt-1"
  />
</template>
